import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  timeInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '36px',
  },

  timePreview: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',

    '& > *': {
      pointerEvents: 'none',
    },

    '& .time': {
      fontWeight: 500,

      '&.empty': {
        color: 'var(--text-hint)',
      },
    },

    '& p': {
      fontSize: '11px',

      '@media screen and (min-width: 1441px)': {
        fontSize: '14px',
      },
    },
  },
}));

export default useStyles;
